import React, { Component, createRef } from "react";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";

import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { districts, provinces } from "../../../../Components/Data/Province";
import { getCountries } from "../../../../Components/Data/Countries";
import { publicImageUrl } from "../../../../Config/publicImageUrl";
import { CustomLinearProgress } from "../../../../Components/CustomLinearProgress/CustomLinearProgress";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#184e98",
    },
  },
});

class AddStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panRef: createRef(),
      countries: [],
      isSame: false,
      data: {
        profileImage: "",
        fullName: "",
        gender: "",
        dateOfBirth: "",
        email: "",
        mobileNumber: "",
        contractType: "",
        maritalStatus: "",
        bloodGroup: "",
        department: "",
        panNumber: "",
        joinedDate: "",
        citizenshipId: "",
        designation: "",
        bankDetails: {
          accountNumber: "",
          bankName: "",
          branchName: "",
        },
        temporaryAddress: {
          district: "",
          vdc: "",
          province: "",
          nationality: "",
          country: "",
          city: "",
        },
        permanentAddress: {
          district: "",
          vdc: "",
          nationality: "",
          province: "",
          country: "",
          city: "",
        },
      },
      error: {
        imageError: "",
        mobileError: "",
        bankError: "",
        panError: "",
        citizenshipError: "",
      },
      files: [],
      fileUrl: "",
      imageToDelete: "",
      imageLoading: false,
      deleteImage: false,
      imagePercentage: 0,
      loading: false,
    };
  }

  componentDidMount() {
    this.getCountryData();
    if (this.props.editStatus) {
      this.getStaff(this.props.staffId);
    }
  }
  getCountryData = async () => {
    let countries = await getCountries();
    this.setState({
      countries,
    });
  };

  getStaff = async (staffId) => {
    try {
      const response = await Axios.get(`${url}/api/staffs/${staffId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.staff.length !== 0) {
        this.setState({
          imageToDelete: response.data.staff.profileImage,
          data: {
            ...this.state.data,
            profileImage: response.data.staff.profileImage,
            fullName: response.data.staff.fullName,
            gender: response.data.staff.gender,
            dateOfBirth: response.data.staff.dateOfBirth,
            email: response.data.staff.email ? response.data.staff.email : "",
            mobileNumber: response.data.staff.mobileNumber,
            contractType: response.data.staff.contractType,
            maritalStatus: response.data.staff.maritalStatus,
            bloodGroup: response.data.staff.bloodGroup,
            department: response.data.staff.department,
            panNumber: response.data.staff.panNumber
              ? response.data.staff.panNumber
              : "",
            joinedDate: response.data.staff.joinedDate,
            citizenshipId: response.data.staff.citizenshipId,
            designation: response.data.staff.designation,
            bankDetails: response.data.staff.bankDetails
              ? {
                  accountNumber: response.data.staff.bankDetails.accountNumber,
                  bankName: response.data.staff.bankDetails.bankName,
                  branchName: response.data.staff.bankDetails.branchName,
                }
              : { accountNumber: "", bankName: "", branchName: "" },
            temporaryAddress: {
              district: response.data.staff.temporaryAddress.district,
              vdc: response.data.staff.temporaryAddress.vdc,
              province: response.data.staff.temporaryAddress.province,
              nationality: response.data.staff.temporaryAddress.nationality,
              country: response.data.staff.temporaryAddress.country,
              city: response.data.staff.temporaryAddress.city,
            },
            permanentAddress: {
              district: response.data.staff.permanentAddress.district,
              vdc: response.data.staff.permanentAddress.vdc,
              nationality: response.data.staff.permanentAddress.nationality,
              province: response.data.staff.permanentAddress.province,
              country: response.data.staff.permanentAddress.country,
              city: response.data.staff.permanentAddress.city,
            },
          },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStaff(staffId);
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleBankDetails = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        bankDetails: {
          ...this.state.data.bankDetails,
          [e.target.name]: e.target.value,
        },
      },
    });
  };
  handleTemporaryAddress = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        temporaryAddress: {
          ...this.state.data.temporaryAddress,
          [e.target.name]: e.target.value,
        },
      },
    });
  };
  handlePermanentAddress = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        permanentAddress: {
          ...this.state.data.permanentAddress,
          [e.target.name]: e.target.value,
        },
      },
    });
  };

  handleSameChange = (e) => {
    if (e.target.checked) {
      this.setState({
        data: {
          ...this.state.data,
          permanentAddress: { ...this.state.data.temporaryAddress },
        },
      });
    }
    this.setState({ isSame: e.target.checked });
  };

  handleStaffImage = async (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      files,
      imageLoading: true,
    });

    if (this.props.editStatus) {
      this.setState({
        deleteImage: true,
      });
    }

    reader.onload = () => {
      this.setState({ fileUrl: window.URL.createObjectURL(e.target.files[0]) });
    };

    reader.onprogress = (data) => {
      this.setState({
        imageLoading: false,
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          imagePercentage: progress,
        });
      }
    };
    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleStaffImageProgress = () =>
    this.state.imagePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.imagePercentage}
          variant="determinate"
        />
        {this.state.imagePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.imagePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  checkError = (citizenship) => {
    let imageError = "";
    let bankError = "";
    let bankErrorEmpty = false;
    let mobileError = "";
    let citizenshipError = citizenship ? citizenship : "";

    if (this.props.editStatus) {
      if (this.state.data.profileImage === "") {
        imageError = "Please insert image.";
      }
    } else {
      if (this.state.fileUrl === "") {
        imageError = "Please insert image.";
      }
    }

    if (this.state.data.mobileNumber.length !== 10) {
      mobileError = "Please enter 10 digit number";
    }

    if (
      this.state.data.bankDetails.accountNumber === "" &&
      this.state.data.bankDetails.bankName === "" &&
      this.state.data.bankDetails.branchName === ""
    ) {
      bankErrorEmpty = false;
    } else {
      if (this.state.data.bankDetails.accountNumber === "") {
        bankErrorEmpty = true;
      }
      if (this.state.data.bankDetails.bankName === "") {
        bankErrorEmpty = true;
      }
      if (this.state.data.bankDetails.branchName === "") {
        bankErrorEmpty = true;
      }
    }
    if (bankErrorEmpty) {
      bankError =
        "Either enter every details of bank or leave every field empty";
    }
    if (citizenshipError || imageError || mobileError || bankError) {
      this.setState({
        error: { citizenshipError, imageError, mobileError, bankError },
      });
      return true;
    } else {
      this.setState({
        error: {
          citizenshipError: "",
          imageError: "",
          mobileError: "",
          bankError: "",
        },
      });
      return false;
    }
  };

  getData = (data) => {
    let changedData = { ...data };

    if (!data.email) {
      delete changedData.email;
    }
    if (!data.panNumber) {
      delete changedData.panNumber;
    }
    if (
      !data.bankDetails.accountNumber ||
      !data.bankDetails.bankName ||
      !data.bankDetails.branchName
    ) {
      delete changedData.bankDetails;
    }

    return changedData;
  };

  uploadImage = async (files) => {
    const {
      data: { signedUrl, key },
    } = await Axios.post(`${url}/api/uploads`, {
      dir: "Staffs",
      contentType: files.type,
    });
    await Axios.put(signedUrl, this.state.files, {
      headers: {
        "content-type": files.type,
      },
    });
    await Axios.post(`${url}/api/uploads/public`, {
      fileName: key,
    });

    return key;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        if (this.props.editStatus) {
          let changedData = this.getData(this.state.data);
          let data;
          if (this.state.deleteImage === false) {
            data = {
              ...changedData,
              profileImage: this.state.imageToDelete,
            };
          } else {
            let imageKey = await this.uploadImage(this.state.files);
            data = { ...changedData, profileImage: imageKey };
          }
          const editResponse = await Axios.put(
            `${url}/api/staffs/${this.props.staffId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );

          if (this.state.deleteImage) {
            await Axios.post(
              `${url}/api/uploads/delete/`,
              {
                fileName: this.state.imageToDelete,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.props.adminToken}`,
                },
              }
            );
          }

          if (editResponse.data.message === "staff edited successfully") {
            this.props.history.push(`/administration/staffs`);
          }
        } else {
          let imageKey = await this.uploadImage(this.state.files);
          let data = this.getData(this.state.data);
          data = { ...this.state.data, profileImage: imageKey };
          const response = await Axios.post(`${url}/api/staffs`, data, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          if (response.data.message === "staff added successfully") {
            this.props.history.push(`/administration/staffs`);
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message ===
          "Staff with given citizenship Id already added"
        ) {
          console.clear();
          this.checkError(error.response.data.message);
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          {this.props.studentId ? (
            <PageTitle title="Edit Employee Details" />
          ) : (
            <PageTitle title="Add Employee Details" />
          )}

          <form onSubmit={this.handleSubmit}>
            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                General Information
              </div>

              <div className={classes.imageStyle}>
                <div style={{ fontSize: 20 }}>Staff Image</div>
                <div>
                  {this.state.fileUrl ? (
                    <img
                      src={`${this.state.fileUrl}`}
                      alt={this.state.data.fullName}
                      style={{ width: 100, height: 100 }}
                    />
                  ) : (
                    this.state.data.profileImage && (
                      <img
                        src={`${publicImageUrl}/${this.state.data.profileImage}`}
                        alt={this.state.data.fullName}
                        style={{ width: 100, height: 100 }}
                      />
                    )
                  )}
                </div>
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleStaffImage}
                  />
                  <div>
                    <div style={{ padding: 10 }}>
                      {this.handleStaffImageProgress()}
                    </div>
                    <div>
                      {this.state.imageLoading === true && <CircularProgress />}
                    </div>
                  </div>
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    {this.state.error.imageError}
                  </div>
                </div>
              </div>

              <TextField
                name="fullName"
                type="text"
                required
                label="Employee Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter employee's full name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.fullName}
                onChange={this.handleChange}
              />
              <TextField
                name="gender"
                select
                required
                label="Gender"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.gender}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
              </TextField>
              <TextField
                name="dateOfBirth"
                type="date"
                required
                label="Date of Birth"
                variant="outlined"
                margin="normal"
                placeholder="Enter birth date in AD"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.dateOfBirth}
                onChange={this.handleChange}
              />

              <TextField
                name="email"
                type="email"
                label="Email"
                variant="outlined"
                margin="normal"
                placeholder="Enter email address"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.email}
                onChange={this.handleChange}
              />
              <TextField
                name="mobileNumber"
                type="tel"
                required
                label="Mobile Number"
                variant="outlined"
                margin="normal"
                placeholder="Enter mobile number"
                error={this.state.error.mobileError ? true : false}
                helperText={this.state.error.mobileError}
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.mobileNumber}
                onChange={this.handleChange}
              />

              <TextField
                name="contractType"
                select
                required
                label="Contract Type"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.contractType}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Full Time">Full time</option>
                <option value="Part Time">Part Time</option>
              </TextField>

              <TextField
                name="maritalStatus"
                select
                required
                label="Marital Status"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.maritalStatus}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Married">Married</option>
                <option value="Unmarried">Unmarried</option>
              </TextField>

              <TextField
                name="bloodGroup"
                select
                required
                label="Blood Group"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.bloodGroup}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="O-">O-</option>
                <option value="O+">O+</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
              </TextField>
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                Staff Information
              </div>

              <TextField
                name="department"
                select
                required
                label="Department"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.department}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Administration">Administrative Staff</option>
                <option value="Teaching">Teaching Staff</option>
                <option value="Non-Teaching">Non-Teaching Staff</option>
              </TextField>
              <TextField
                name="panNumber"
                type="number"
                label="PAN Number"
                variant="outlined"
                margin="normal"
                placeholder="Enter PAN number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.panNumber}
                onChange={this.handleChange}
              />
              <TextField
                name="joinedDate"
                type="date"
                required
                label="Date of Joining"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.joinedDate}
                onChange={this.handleChange}
              />

              <TextField
                name="citizenshipId"
                required
                label="Citizenship Number"
                type="number"
                variant="outlined"
                margin="normal"
                error={this.state.error.citizenshipError ? true : false}
                helperText={this.state.error.citizenshipError}
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.citizenshipId}
                onChange={this.handleChange}
              ></TextField>

              <TextField
                name="designation"
                type="text"
                required
                label="Designation"
                variant="outlined"
                margin="normal"
                placeholder="Enter the designation for this employee"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.designation}
                onChange={this.handleChange}
              />
            </div>

            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                Bank Details
              </div>

              {this.state.error.bankError && (
                <div style={{ color: "#ff3333", fontWeight: "bold" }}>
                  {this.state.error.bankError}
                </div>
              )}
              <TextField
                name="accountNumber"
                type="text"
                label="Account Number"
                variant="outlined"
                margin="normal"
                placeholder="Enter account number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.bankDetails.accountNumber}
                onChange={this.handleBankDetails}
              />
              <TextField
                name="bankName"
                type="text"
                label="Bank Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter full name of employee's bank"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.bankDetails.bankName}
                onChange={this.handleBankDetails}
              />
              <TextField
                name="branchName"
                type="text"
                label="Branch Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter branch name of bank"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.bankDetails.branchName}
                onChange={this.handleBankDetails}
              />
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                Temprorary Address
              </div>
              <TextField
                name="vdc"
                type="text"
                required
                label="VDC/Municipality"
                variant="outlined"
                margin="normal"
                placeholder="Enter VDC/Municipality"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.temporaryAddress.vdc}
                onChange={this.handleTemporaryAddress}
              />

              <TextField
                name="city"
                type="text"
                required
                label="City"
                variant="outlined"
                margin="normal"
                placeholder="Enter city"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.temporaryAddress.city}
                onChange={this.handleTemporaryAddress}
              />

              <TextField
                name="district"
                select
                required
                label="District"
                variant="outlined"
                margin="normal"
                placeholder="Enter district"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.temporaryAddress.district}
                onChange={this.handleTemporaryAddress}
              >
                <option value="">Select Any One</option>
                {districts.map((district, index) => (
                  <option key={index} value={district}>
                    {district}
                  </option>
                ))}
              </TextField>

              <TextField
                name="province"
                select
                required
                label="Province"
                variant="outlined"
                margin="normal"
                placeholder="Enter Province"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.temporaryAddress.province}
                onChange={this.handleTemporaryAddress}
              >
                <option value="">Select Any One</option>
                {provinces.map((province, index) => (
                  <option key={index} value={province}>
                    {province}
                  </option>
                ))}
              </TextField>

              <TextField
                name="nationality"
                type="text"
                required
                label="Nationality"
                variant="outlined"
                margin="normal"
                placeholder="Enter nationality date in AD"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.temporaryAddress.nationality}
                onChange={this.handleTemporaryAddress}
              />

              <TextField
                name="country"
                select
                required
                label="Country"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.temporaryAddress.country}
                onChange={this.handleTemporaryAddress}
              >
                <option value="">Select Any One</option>
                {this.state.countries.map((country, index) => (
                  <option key={index} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </TextField>
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                Permanent Address
              </div>
              <div className={classes.termStyle}>
                <ThemeProvider theme={theme}>
                  <Checkbox
                    color="primary"
                    checked={this.state.isSame}
                    onChange={this.handleSameChange}
                    name="isSame"
                  />
                </ThemeProvider>
                <div>Same as temporaryAddress.</div>
              </div>
              <TextField
                name="vdc"
                type="text"
                required
                label="VDC/Municipality"
                variant="outlined"
                margin="normal"
                placeholder="Enter VDC/Municipality"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.permanentAddress.vdc}
                onChange={this.handlePermanentAddress}
              />

              <TextField
                name="city"
                type="text"
                required
                label="City"
                variant="outlined"
                margin="normal"
                placeholder="Enter city"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.permanentAddress.city}
                onChange={this.handlePermanentAddress}
              />

              <TextField
                name="district"
                select
                required
                label="District"
                variant="outlined"
                margin="normal"
                placeholder="Enter district"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.permanentAddress.district}
                onChange={this.handlePermanentAddress}
              >
                <option value="">Select Any One</option>
                {districts.map((district, index) => (
                  <option key={index} value={district}>
                    {district}
                  </option>
                ))}
              </TextField>

              <TextField
                name="province"
                select
                required
                label="Province"
                variant="outlined"
                margin="normal"
                placeholder="Enter Province"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.permanentAddress.province}
                onChange={this.handlePermanentAddress}
              >
                <option value="">Select Any One</option>
                {provinces.map((province, index) => (
                  <option key={index} value={province}>
                    {province}
                  </option>
                ))}
              </TextField>

              <TextField
                name="nationality"
                type="text"
                required
                label="Nationality"
                variant="outlined"
                margin="normal"
                placeholder="Enter nationality "
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.permanentAddress.nationality}
                onChange={this.handlePermanentAddress}
              />

              <TextField
                name="country"
                select
                required
                label="Country"
                variant="outlined"
                margin="normal"
                className={classes.inputWithMargin}
                SelectProps={{
                  native: true,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.permanentAddress.country}
                onChange={this.handlePermanentAddress}
              >
                <option value="">Select Any One</option>
                {this.state.countries.map((country, index) => (
                  <option key={index} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </TextField>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                className={classes.buttonStyle}
              >
                Submit
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddStaff)));
